import { createAsyncThunk } from "@reduxjs/toolkit";
import { auth, facebookporvider, provider } from "../config/firebase";
import { signInWithPopup } from "firebase/auth";
import axiosInstance from "../config/axiosConfig";

export const loginwithgoogle = createAsyncThunk(
  "auth/loginwithgoogle",
  async ({ handleCloseForm }, { rejectWithValue }) => {
    try {
      const result = await signInWithPopup(auth, provider);
      handleCloseForm();
      return result.user;
    } catch (e) {
      console.error(e);
      return rejectWithValue(e);
    }
  }
);

export const loginwithfacebook = createAsyncThunk(
  "auth/loginwithfacebook",
  async ({ handleCloseForm }, { rejectWithValue }) => {
    try {
      const result = await signInWithPopup(auth, facebookporvider);
      handleCloseForm();
      return result.user;
    } catch (e) {
      console.error(e);
      return rejectWithValue(e);
    }
  }
);
